/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Pearl_Quail_PokeInputs */

const en_teal_pearl_quail_poke = /** @type {(inputs: Teal_Pearl_Quail_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General access`)
};

const de_teal_pearl_quail_poke = /** @type {(inputs: Teal_Pearl_Quail_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Freigabe`)
};

/**
* | output |
* | --- |
* | "General access" |
*
* @param {Teal_Pearl_Quail_PokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teal_pearl_quail_poke = /** @type {((inputs?: Teal_Pearl_Quail_PokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Pearl_Quail_PokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_teal_pearl_quail_poke(inputs)
	return de_teal_pearl_quail_poke(inputs)
});